import { Icon, Container, Dropdown } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { WaitingAreaInfoForCallersFileNotAccepted } from 'actions/waitingArea.js';
import Dropzone from 'react-dropzone';
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { generateTrucatedFileName } from 'businessLogic/fileName.js';
import { Media } from '../../../../mediaSetting';

export default function FileUploader(props) {
  const dispatch = useDispatch();
  const dropZoneRef = useRef();

  const [defaultFileName, setDefaultFileName] = useState(props.defaultFileName);
  const [currentFileName, setCurrentFileName] = useState(props.currentFileName);
  const [isDefaultFile, setIsDefaultFile] = useState(props.isDefaultFile);
  const [isRemovedCurrectFile, setIsRemovedCurrectFile] = useState(false);
  const [accpetedFile, setAccpetedFile] = useState(null); // When user select custom file and file type & size accepted
  const [rejectedFile, setRejectedFile] = useState(null); // When user select custom file and file type & size is not supporteds
  const [uploadedFileName, setUploadedFileName] = useState('');
  const [maxSize, setMaxSize] = useState(props.maxSize || 4000000);
  const [uploadedFileBase64, setUploadedFileBase64] = useState();

  const onDrop = (acceptedFiles, rejectedFiles) => {
    // If file is rejected because of file type / file size, need to set state to show the error
    if (rejectedFiles && rejectedFiles.length > 0) {
      setRejectedFile(rejectedFiles[0]);
      setIsRemovedCurrectFile(false); //Need to test then pass mark
      setUploadedFileName('');
      setAccpetedFile(null);
      setCurrentFileName(null);

      dispatch(WaitingAreaInfoForCallersFileNotAccepted(true));
    } else if (acceptedFiles && acceptedFiles.length > 0) {
      // If select custom file and this file's type and size are accepted
      setAccpetedFile(acceptedFiles[0]);
      setRejectedFile(null);
      setCurrentFileName(null); //Need to test then pass mark
      setIsRemovedCurrectFile(false);

      dispatch(WaitingAreaInfoForCallersFileNotAccepted(false));
      var file = acceptedFiles[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        let base64String = event.target.result;
        setUploadedFileBase64(base64String);
        setUploadedFileName(file.name);
      };
      reader.readAsDataURL(file);
    }
  };
  useEffect(() => {
    props.setSaveInfoDispatchObj({
      pdf64: uploadedFileBase64 ? uploadedFileBase64 : '',
      fileName: uploadedFileName ? uploadedFileName : '',
      isRemoved: isRemovedCurrectFile,
    });
  }, [uploadedFileBase64, uploadedFileName, isRemovedCurrectFile]);

  const getBase64 = () => {
    if (uploadedFileBase64) {
      return uploadedFileBase64;
    }
    return '';
  };

  const getFileName = () => {
    if (uploadedFileName) {
      return uploadedFileName;
    }
    return '';
  };

  const handleUpload = () => {
    // Need to add this line to make onDrop file everytime
    dropZoneRef.current.fileInputEl.value = null;
    dropZoneRef.current.fileInputEl.click();
    // this is only the event when u click 'upload', it does not mean u choosed file.
  };

  const clearAcceptedFile = () => {
    // Need to add this file, otherwise select will fail after removing the selected file
    dropZoneRef.current.onFileDialogCancel();
    // This is for the file that user tried to upload is cleared
    setAccpetedFile(null);
    setRejectedFile(null);
    setIsRemovedCurrectFile(true);
    setUploadedFileBase64('');
    setRejectedFile(null);
    // Update redux file is accepeted or not status, to show/hide the warning
    dispatch(WaitingAreaInfoForCallersFileNotAccepted(false));
  };

  const clearCurrentFile = () => {
    // Custom has been uploaded and saved, but user wants to reset to default
    setIsRemovedCurrectFile(true);
    setRejectedFile(null);
    dispatch(WaitingAreaInfoForCallersFileNotAccepted(false));
  };

  const resetCurrentFile = () => {
    // Go back to the state of firstly opening the dialog
    setIsRemovedCurrectFile(false);
    setUploadedFileBase64('');
    setRejectedFile(null);
    dispatch(WaitingAreaInfoForCallersFileNotAccepted(false));
  };

  const renderWarning = (isOnMobileOrTablet) => {
    if (rejectedFile != null) {
      return (
        <div
          className={
            isOnMobileOrTablet
              ? 'small-font-size mrbs color-bad-things-text-on-mobile'
              : 'small-font-size mrbs color-bad-things-text'
          }
        >
          <div className="bold">
            {rejectedFile.type.indexOf('pdf') > -1 && rejectedFile.size > maxSize
              ? APP.LANGUAGE.InformationForCallersModal.ExceedMaxSizeWarning
              : APP.LANGUAGE.InformationForCallersModal.FileTypeNotAcceptWarning}
          </div>
        </div>
      );
    } else return '';
  };

  const renderFileNameinInDropdown = (truncateString, colourClass) => {
    return (
      <div className={colourClass || 'info-color'}>
        <Icon name="file pdf outline" />
        {truncateString ? generateTrucatedFileName(truncateString) : props.currentFileName}
      </div>
    );
  };

  const renderAddedFile = () => {
    if (rejectedFile) {
      // User uploads a rejected file
      return (
        <Dropdown
          trigger={renderFileNameinInDropdown(rejectedFile.name, 'color-bad-things-text')}
          icon="caret down"
          id="pil-file-dropdown"
          className="inline-flex center-flex space-between max-width full-height bold color-bad-things-text"
        >
          <Dropdown.Menu>
            <Dropdown.Item onClick={handleUpload}>
              <Icon name="folder open" />
              <span className="text">{APP.LANGUAGE.InformationForCallersModal.UploadBtnText}</span>
            </Dropdown.Item>
            <Dropdown.Item onClick={clearAcceptedFile}>
              <Icon name="undo" />
              <span className="text">{APP.LANGUAGE.InformationForCallersModal.ResetText}</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      );
    } else if (accpetedFile == null && !isDefaultFile && isRemovedCurrectFile == false) {
      // There is a custom file saved in the server
      return (
        <Dropdown
          trigger={renderFileNameinInDropdown(currentFileName)}
          icon="caret down"
          id="pil-file-dropdown"
          className="inline-flex center-flex space-between max-width full-height bold"
        >
          <Dropdown.Menu>
            <Dropdown.Item onClick={handleUpload}>
              <Icon name="folder open" />
              <span className="text">{APP.LANGUAGE.InformationForCallersModal.UploadBtnText}</span>
            </Dropdown.Item>
            <Dropdown.Item onClick={clearCurrentFile}>
              <Icon name="undo" />
              <span className="text">{APP.LANGUAGE.InformationForCallersModal.ResetText}</span>
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                props.downloadFunction();
              }}
            >
              <Icon name="download" />
              <span className="text">{APP.LANGUAGE.InformationForCallersModal.DownloadCurrentFile}</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      );
    } else if (accpetedFile == null && !isDefaultFile && isRemovedCurrectFile == true) {
      // User remove the cutom file that is saved in server
      return (
        <Dropdown
          trigger={renderFileNameinInDropdown(defaultFileName)}
          icon="caret down"
          id="pil-file-dropdown"
          className="inline-flex center-flex space-between max-width full-height bold"
        >
          <Dropdown.Menu>
            <Dropdown.Item onClick={handleUpload}>
              <Icon name="folder open" />
              <span className="text">{APP.LANGUAGE.InformationForCallersModal.UploadBtnText}</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      );
    } else if (accpetedFile) {
      // User uploads a file from their computer
      return (
        <Dropdown
          trigger={renderFileNameinInDropdown(accpetedFile.name)}
          icon="caret down"
          id="pil-file-dropdown"
          className="inline-flex center-flex space-between max-width full-height bold"
        >
          <Dropdown.Menu>
            <Dropdown.Item onClick={handleUpload}>
              <Icon name="folder open" />
              <span className="text">{APP.LANGUAGE.InformationForCallersModal.UploadBtnText}</span>
            </Dropdown.Item>
            <Dropdown.Item onClick={clearAcceptedFile}>
              <Icon name="undo" />
              <span className="text">{APP.LANGUAGE.InformationForCallersModal.ResetText}</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      );
    } else {
      // Default auto generated file
      return (
        <Dropdown
          trigger={renderFileNameinInDropdown(currentFileName)}
          icon="caret down"
          id="pil-file-dropdown"
          className="inline-flex center-flex space-between max-width full-height bold"
        >
          <Dropdown.Menu>
            <Dropdown.Item onClick={handleUpload}>
              <Icon name="folder open" />
              <span className="text">{APP.LANGUAGE.InformationForCallersModal.UploadBtnText}</span>
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                props.downloadFunction();
              }}
            >
              <Icon name="download" />
              <span className="text">{APP.LANGUAGE.InformationForCallersModal.DownloadCurrentFile}</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      );
    }
  };

  const userMenuOptionTrigger = <Icon name="camera" className="fl pdls" />;
  const itemClass = 'no-sub-menu';
  const supaDropdownUserMenuClassName = 'ui dropdown  item fr imageUpload';

  return (
    <div className="mrbm">
      <Dropzone
        disableClick={true}
        multiple={false}
        maxSize={maxSize}
        ref={dropZoneRef}
        onDrop={onDrop}
        className="drop-zone pointer pdtnull"
        accept=".pdf,application/pdf"
      >
        <Container fluid className="inline-flex center-flex max-width" as={Media} greaterThanOrEqual="computer">
          <div style={{ textAlign: 'left' }} className="added-file-label max-width">
            {renderAddedFile()}
          </div>
        </Container>
        <Container fluid className="max-width mrts" as={Media} at="tablet" />
        <Container fluid className="max-width center-text mrts" as={Media} at="mobile" />
        <Container fluid className="max-width" as={Media} at="tablet">
          <div style={{ textAlign: 'left' }} className="added-file-label mrts">
            {renderAddedFile()}
          </div>
        </Container>
        <Container fluid className="max-width" as={Media} at="mobile">
          <div style={{ textAlign: 'left' }} className="added-file-label auto-margin mrts">
            {renderAddedFile()}
          </div>
        </Container>
      </Dropzone>
      <Container fluid as={Media} greaterThanOrEqual="computer">
        {renderWarning(false)}
      </Container>
      <Container fluid as={Media} at="tablet">
        {renderWarning(true)}
      </Container>
      <Container fluid as={Media} at="mobile" className="auto-margin hints-message-mobile">
        {renderWarning(true)}
      </Container>
    </div>
  );
}

FileUploader.propTypes = {
  currentFileName: PropTypes.string, // PIL file name of file which is saved in server
  isRemovedCurrectFile: PropTypes.bool, // If the saved file is removed by user
  isDefaultFile: PropTypes.bool, // If the file is the default auto-generated file
  accpetedFile: PropTypes.object, // file object that user tries to upload
  rejectedFile: PropTypes.object, // file object that user tries to upload but rejected becuase of size or file type
  uploadedFileBase64: PropTypes.string, // PIL base64 string of file which user tries to upload
  uploadedFileName: PropTypes.string, // PIL file name of file which user tries to upload
  maxSize: PropTypes.number, // PIL max size of file that user can upload
};
